import { cn } from '@sohanemon/utils';

export interface OrbitingCirclesProps {
	className?: string;
	children?: React.ReactNode;
	reverse?: boolean;
	duration?: number;
	delay?: number;
	radius?: number;
	path?: boolean;
	index?: number;
	total?: number;
}

export default function OrbitingCircles({
	className,
	children,
	reverse,
	duration = 20,
	delay = 10,
	radius = 50,
	path = true,
	index = 0,
	total = 1,
}: OrbitingCirclesProps) {
	const angle = (360 / total) * index;

	return (
		<>
			{path && (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					aria-label="Orbiting circles"
					version="1.1"
					className="pointer-events-none absolute inset-0 size-full"
				>
					<circle
						className="stroke-1 stroke-primary/20"
						cx="50%"
						cy="50%"
						r={radius}
						fill="none"
					/>
				</svg>
			)}
			<div
				style={
					{
						'--duration': duration,
						'--radius': radius,
						'--delay': -delay,
						'--angle': `${angle}deg`,
					} as React.CSSProperties
				}
				className={cn(
					'hover:paused absolute flex size-fit transform-gpu animate-orbit items-center justify-center rounded-full [animation-delay:calc(var(--delay)*1000ms)]',
					{ 'direction-[reverse]': reverse },
					className,
				)}
			>
				{children}
			</div>
		</>
	);
}
